<template>
  <div style="background: transparent" class="ml-3">
    <v-row align="center">
      <v-item-group
        v-model="window"
        class="shrink mr-2"
        @change="page_chaged"
        mandatory
        tag="v-flex"
      >
        <v-item
          v-for="(page, pindex) in pages"
          :key="pindex"
          v-slot="{ active, toggle }"
          :forceUpdate="forceUpdate"
        >
          <div>
            <v-btn :input-value="active" icon @click="toggle">
              <v-icon>mdi-record</v-icon>
            </v-btn>
          </div>
        </v-item>
      </v-item-group>

      <v-col>
        <v-window v-model="window" vertical>
          <v-window-item v-for="(page, index) in pages" :key="index">
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="4"
                lg="3"
                v-for="event in page"
                :key="event.idIntervento"
              >
                <EventsViewerCard
                  :eventId="event.idIntervento"
                ></EventsViewerCard>
              </v-col>
            </v-row>
          </v-window-item>
        </v-window>
      </v-col>
    </v-row>

    <v-col cols="auto">
      <v-dialog
        transition="dialog-top-transition"
        v-model="dialog"
        persistent
        max-width="600"
      >
        <template>
          <v-card>
            <v-toolbar color="info" dark>
              <v-row align="center">
                <v-col class="grow title"> Nessun evento da mostrare! </v-col>
                <v-col class="shrink">
                  <v-btn light :to="{ name: 'dashboard' }"
                    >Torna al dashboard</v-btn
                  >
                </v-col>
              </v-row>
            </v-toolbar>
          </v-card>
        </template>
      </v-dialog>
    </v-col>
  </div>
</template>


<style lang="scss">
.blink {
  animation: blinker 1s ease infinite;
}
.v-window.v-item-group.theme--light {
  z-index: 4000 !important;
}
.v-item--active .v-icon.notranslate.mdi.mdi-record.theme--light {
  color: white !important;
}
@keyframes blinker {
  50% {
    opacity: 0.7;
  }
}
</style> 
<script>
import Vue from 'vue';
import EasyPlanClient from "../../utils/EasyPlanClient";
import SessionHelper from "../../utils/SessionHelper";
import EventType from "../../settings/EventType";
import EventsViewerCard from "./EventsViewerCard";
export default {
  components: { EventsViewerCard },
  props: {
    slideSeconds: { type: Number, default: 0 },
    maxItemXPage: { type: Number, default: 8 },
    date: { type: Date, default: new Date() },
  },
  data: () => ({
    window: 1,
    events: [],
    pages: [],
    forceUpdate:false,
    dialog: false,
  }),
  watch: {
    date(newVal) {
      this.refreshGrid();
    },
  },
  mounted() {
    if (this.slideSeconds > 0) {
      this.window = -1;
      setInterval(() => {
        if (this.window < this.pages.length) {
          this.window++;
        } else this.window = 0;
      }, this.slideSeconds * 1000);
    }
  },
  created() {
    SessionHelper.loadUserInfo(this.$route.params.companyAlias);
    SessionHelper.loadCompanyInfo(this.$route.params.companyAlias);

    this.refreshGrid();
  },

  methods: {
    forceRender(){
        this.forceUpdate=!this.forceUpdate;
        this.$forceUpdate();
    },
    page_chaged(page, bo) {
      console.debug("CHANGED", page);
      console.debug("page", page);
      console.debug("bo", bo);
    },
    refreshGrid() {
      console.debug("REFRESH");
      let t = this;
      this.events = [];
      this.loadEvents((events) => {
        t.pages = [];
        this. forceRender();
        events = events.filter((e) => e.tipo == EventType.Intervento);
        this.events = events ;
        this.dialog = this.events.length == 0;
        var iPage = -1;
        let tmpPages = [];
        for (let iItems = 0; iItems < events.length; iItems++) {
          if (iItems % t.maxItemXPage == 0) {
            iPage++;
            console.debug("pages", tmpPages);
            console.debug("newPage", iPage);
            tmpPages[iPage] = [];
          }

          tmpPages[iPage].push(events[iItems]);
        }
        t.pages = tmpPages;
        t.forceRender();
        let refreshInterval = 3000;
        refreshInterval = this.slideSeconds * 1000 * this.pages.length;
        console.debug("refresh interval", refreshInterval);
        setTimeout(() => {
          this.refreshGrid();
        }, refreshInterval);
      });
    },
    loadEvents(callback = () => {}) {
      EasyPlanClient.Event.FindByCompanyAliasDateFromTo(
        this.$route.params.companyAlias,
        this.$props.date,
        this.$props.date
      )
        .then((res) => {
          this.events = [];
          callback(res.data.data);
          console.log(this.events);
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },
  },
};
</script>

